import { render, staticRenderFns } from "./FeatureCollaboratorLimits.vue?vue&type=template&id=30a99460&scoped=true&"
import script from "./FeatureCollaboratorLimits.vue?vue&type=script&lang=js&"
export * from "./FeatureCollaboratorLimits.vue?vue&type=script&lang=js&"
import style0 from "./FeatureCollaboratorLimits.vue?vue&type=style&index=0&id=30a99460&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a99460",
  null
  
)

export default component.exports